<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        @keydown.esc="close"
    >
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click.native="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('common.chat.title') }}</v-toolbar-title>
            </v-toolbar>

            <template v-if="loading">
                <progress-circle/>
            </template>
            <template v-else>
                <v-card-text>
                    <div class="chat-text-container">
                        <div v-for="(message, index) in messages" :key="index">
                            <div v-if="message.sender === 'user'" :class="{'text-right': true }">
                                <div class="v-identify">{{ $t('common.chat.you') }}</div>
                                <div class="v-message v-message--user">{{ message.text }}</div>
                            </div>
                            <div v-else-if="message.sender === 'bot'" :class="{'v-message': true , 'text-left':true }">
                                <div class="v-identify">{{ $t('common.chat.system') }}</div>
                                <div v-html="convertMarkdown(message.text)"></div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <div class="chat-textarea-container">
                    <v-progress-linear
                        v-show="waitingIA"
                        indeterminate
                        color="primary"
                    ></v-progress-linear>
                    <v-container>
                        <div class="input-container">
                            <v-textarea
                                v-model="newMessage"
                                auto-grow
                                outlined
                                dense
                                hide-details
                                rows="1"
                                append-outer-icon="mdi-send"
                                :placeholder="$t('common.chat.message')"
                                type="text"
                                @click:append-outer="send"
                                background-color="white"
                                @keydown.enter.prevent="send"
                                :disabled="waitingIA"
                            ></v-textarea>
                        </div>
                    </v-container>
                </div>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import API from '@/api'
import ProgressCircle from '@/components/ProgressCircle'
import marked from 'marked'

export default {
    components: {
        ProgressCircle
    },
    props: ['setup'],
    data () {
        return {
            dialog: true,
            loading: true,
            waitingIA: false,
            newMessage: '',
            messages: [
                // { sender: 'user', text: 'Olá! Como posso ajudar?' },
                // { sender: 'bot', text: '# Marked in the browser\n\nRendered by **marked**.' }
            ]
        }
    },
    mounted () {
        this.setupIA()
    },
    methods: {
        convertMarkdown (text) {
            return marked(text)
        },
        clearMessage () {
            this.newMessage = ''
        },
        close () {
            this.$emit('close')
        },
        send () {
            this.waitingIA = true
            let endpoint = API.EndPoints.sendContractGPTMessage
            let params = {
                contract: this.$route.params.id,
                message: this.newMessage
            }
            this.messages.push({ sender: 'user', text: this.newMessage })
            this.newMessage = ''
            new API(endpoint, params).request().then(async response => {
                this.waitingIA = false
                this.messages.push({ sender: 'bot', text: response.body.result })
            }, (e) => {
                const message = (e && e.body.error) ? e.body.error : this.$t('common.chat.error')
                alert(message)
                this.waitingIA = false
            })
        },
        setupIA () {
            this.loading = true
            let endpoint = API.EndPoints.createContractGPTChat
            let params = {
                contract: this.$route.params.id
            }
            new API(endpoint, params).request().then(async response => {
                const { fileId, threadId, assistantId } = response.body.result
                this.setup.OAIFileId = fileId
                this.setup.OAIThreadId = threadId
                this.setup.OAIAssistantId = assistantId
                this.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>

<style lang="stylus">
    .v-dialog__content.v-dialog__content--active,
    .v-dialog__content.v-dialog__content--active .full-screen
        min-height: 100vh
    .v-dialog
        .v-card
            .v-card__text
                padding-bottom: 90px
    .chat-text-container
        margin-top: 32px
    .v-identify
        font-size: 20px
        color: black
        font-weight: 600
        margin-bottom: 12px
    .v-message.v-message--user
        font-size: 16px
        color: black
        font-weight: 400
    .chat-textarea-container
        background-color: #f6f8f9
        position: fixed
        width: 100%
        left: 0
        right: 0
        bottom: 0
        outline: none
        z-index: 10
    .input-container
        border: 1px solid rgba(0, 0, 0, 0.42)
        background-color: white
        overflow: hidden
        padding: 5px
        .v-input.v-text-field--outlined.v-input--dense
            fieldset
                border-style: unset
            textarea
                overflow: auto
                max-height: 150px
            .v-input__append-outer
                bottom: 8px
                -ms-flex-item-align: end
                align-self: flex-end
                position: sticky
                right: 5px
</style>
